const genRandomSeed = () => `${Math.random()}`.replace('.', '-')

export default genRandomSeed
